export const positiveNumberWithZero = /^(([1-9][0-9]*)|0{1})$/;
export const positiveFloatNumberWithZero = /^(([1-9][0-9]*)|0{1})((\.)[0-9]*)?$/;
export const cphNumberMask = [/\d/, /\d/, "/", /\d/, /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/];
export const cphNumber = /^\d{2}\/\d{3}\/\d{4}$/;
export const phone = /^([0-9]|-|\(|\))*$/;
